import React from 'react'
import { Typography, Box } from '@mui/material'

const StockHeader = () => {
  return (
    <Box sx={{ mb: { xs: 2.5, sm: 3, md: 3.5 } }}>
      <Typography
        variant="h4"
        component="h1"
        sx={{
          fontWeight: 700,
          color: 'text.primary',
          fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
          mb: { xs: 0.5, sm: 0.75, md: 1 },
        }}>
        Stock Summary
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          fontSize: { xs: '0.8125rem', sm: '0.875rem', md: '0.9375rem' },
        }}>
        Check the number of shirts by type and size that have been registered and already received.
      </Typography>
    </Box>
  )
}

export default StockHeader
